const OrderList = () => import("~/views/Order/ListView.vue");
const OrderEdit = () => import("~/views/Order/EditView.vue");
const OrderDetail = () => import("~/views/Order/Detail/OrderDetail.vue");
const HKOrderDetail = () => import("~/views/Order/Detail/HKOrderDetail.vue");
const HKStockDetail = () => import("~/views/Order/Detail/HKStockDetail.vue");

export { OrderList, OrderDetail, HKOrderDetail, HKStockDetail,OrderEdit };
